var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMhcLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.044,
    height: 28.703,
    viewBox: "0 0 19.044 28.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18251"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12810",
    d: "m1132.214 168.136-2.692.646-2.781 1.284-.85 1.35.85 1.44 3.877 1.423 3.264.54 4.207-.54c1.052-.135 3.078-.591 3.078-.591l2.147-.832.842-1.44-.842-1.35-2.147-1.284-2.164-.646h-1.49l-1.413 1.93-1.213 1.35z",
    transform: "translate(-1125.426 -146.583)",
    style: {
      fill: "#e88183"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12770",
    d: "M94.66-511.927a9.583 9.583 0 0 0-8.167 7.095 10.141 10.141 0 0 0 .067 5.136c.556 1.936 1.482 3.429 4.586 7.381.606.769 1.1 1.42 1.1 1.437s-.129.056-.292.073a12.263 12.263 0 0 0-4.4 1.538 4.024 4.024 0 0 0-1.19 1.285 1.49 1.49 0 0 0-.152.8 1.891 1.891 0 0 0 .629 1.465 7.658 7.658 0 0 0 3.862 1.9 18.8 18.8 0 0 0 5.052.533 19.484 19.484 0 0 0 3.957-.3c2.778-.505 4.8-1.555 5.377-2.79a1.6 1.6 0 0 0 .152-.8 1.9 1.9 0 0 0-.657-1.5 4.8 4.8 0 0 0-1.5-1.055 13.924 13.924 0 0 0-3.575-1.072c-.163-.017-.3-.051-.3-.073s.623-.825 1.375-1.8c2.526-3.227 3.407-4.591 4.047-6.236a9.057 9.057 0 0 0 .606-3.508 8.326 8.326 0 0 0-.365-2.739 9.572 9.572 0 0 0-10.212-6.77zm2.722 1.229a8.473 8.473 0 0 1 6.3 5.529 7.17 7.17 0 0 1 .427 2.722 8.079 8.079 0 0 1-.971 4.069c-.7 1.409-1.229 2.172-3.923 5.635a180.926 180.926 0 0 0-2.6 3.4 13.894 13.894 0 0 1-.887 1.128c-.022 0-.5-.612-1.055-1.353s-1.611-2.122-2.346-3.059c-2.616-3.34-3.4-4.451-4.036-5.742a9.129 9.129 0 0 1-.819-2.335 10.274 10.274 0 0 1 0-3.368 8.4 8.4 0 0 1 4.5-5.888 8.5 8.5 0 0 1 2.75-.848 10.985 10.985 0 0 1 2.66.108zm-3.407 22.069c.488.657.993 1.353 1.128 1.538.309.449.578.573.887.4a8.571 8.571 0 0 0 .814-1.022c.382-.528.892-1.218 1.134-1.538l.438-.578.32.039a18.973 18.973 0 0 1 2.689.595c1.442.471 2.537 1.19 2.711 1.779.443 1.527-3.716 3.042-8.369 3.042-3.564 0-6.943-.876-8.066-2.094-.494-.533-.46-.971.118-1.527a8.991 8.991 0 0 1 4.395-1.706c.976-.173.791-.285 1.801 1.073z",
    transform: "translate(-86.195 511.988)",
    style: {
      fill: "#5c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12771",
    d: "M247.395-471.88a.562.562 0 0 0 .309 1.044.69.69 0 0 0 .528-.561.49.49 0 0 0-.191-.37.488.488 0 0 0-.646-.113z",
    transform: "translate(-238.083 474.203)",
    style: {
      fill: "#e88183"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12772",
    d: "M286.685-464.837a.417.417 0 0 0-.185.387c0 .286.163.466.522.6a6.3 6.3 0 0 1 3.351 3.132 6.68 6.68 0 0 1 .589 2.548.523.523 0 0 0 .191.5.451.451 0 0 0 .747-.006l.2-.2-.034-.6a7.309 7.309 0 0 0-3.536-5.877 5.179 5.179 0 0 0-1.51-.645.585.585 0 0 0-.335.161z",
    transform: "translate(-275.257 467.637)",
    style: {
      fill: "#e88183"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12773",
    d: "M189.145-411.794a4.083 4.083 0 0 0-1.858.988 3.829 3.829 0 0 0-.831 4.591 3.119 3.119 0 0 0 .746 1.016 3.12 3.12 0 0 0 1.016.747 3.757 3.757 0 0 0 3.48-.006 3 3 0 0 0 1.016-.741 3 3 0 0 0 .741-1.016 3.74 3.74 0 0 0 0-3.48 3 3 0 0 0-.741-1.016 3.119 3.119 0 0 0-1.016-.746 3.87 3.87 0 0 0-2.553-.337zm1.386 1.095a2.763 2.763 0 0 1 1.4.775 2.735 2.735 0 0 1 0 3.94 2.682 2.682 0 0 1-1.325.752 2.824 2.824 0 0 1-3.452-2.722 2.866 2.866 0 0 1 2.15-2.728 3.022 3.022 0 0 1 1.227-.018z",
    transform: "translate(-180.428 417.496)",
    style: {
      fill: "#5c5c5c"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhcLocation);
export default __webpack_public_path__ + "static/media/mhc-location.74ad7764e14dcd656d8e31876d221c03.svg";
export { ForwardRef as ReactComponent };